import { render, staticRenderFns } from "./AsbestosCertificateAvailable.vue?vue&type=template&id=4cee58bc&"
import script from "./AsbestosCertificateAvailable.vue?vue&type=script&lang=ts&"
export * from "./AsbestosCertificateAvailable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports